import { UserRole } from "@/interfaces/store/IUserState";

/**
 * Role types created through the back-office PIN flow rather than an email
 * invite (POS Seller, POS Seller Manager). The POS does not offer them in
 * the role select and cannot edit them for now — their role is immutable
 * and they carry no email or social security number.
 */
export const POS_PIN_ROLE_TYPES: number[] = [
  UserRole.ROLE_POS_SELLER,
  UserRole.ROLE_POS_SELLER_MANAGER,
];

/**
 * English fallback labels for the role select, used only when the
 * GET /group/roles catalogue cannot be fetched. Mirrors the back-office
 * role-translations map (role id 9 does not exist backend-side).
 */
export const FALLBACK_ROLE_LABELS: Record<number, string> = {
  [UserRole.ROLE_OWNER]: "Owner",
  [UserRole.ROLE_MANAGER]: "Manager",
  [UserRole.ROLE_SECURITY]: "Security",
  [UserRole.ROLE_SELLER]: "Seller",
  [UserRole.ROLE_ACCOUNTING]: "Accounting",
  [UserRole.ROLE_SELLER_MANAGER]: "Seller manager",
  [UserRole.ROLE_DEVELOPER]: "Developer",
  [UserRole.ROLE_RESTRICTED_MANAGER]: "Restricted manager",
  [UserRole.ROLE_READ_ONLY]: "Read only",
  [UserRole.ROLE_PROMOTER]: "Promoter",
  [UserRole.ROLE_SELLER_NO_DISCOUNT]: "Seller without discount",
  [UserRole.ROLE_POS_SELLER]: "POS Seller",
  [UserRole.ROLE_POS_SELLER_MANAGER]: "POS Seller Manager",
};

/** Confirmed member state as returned by GET /group/{groupId}/role. */
export const MEMBER_STATE_CONFIRMED = 1;
